"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.estimateVideoCostCents = exports.VIDEO_BUDGET_EXCEEDED_CODE = exports.VIDEO_OFFER_MAX_CHARS = exports.isVideoEligiblePlatform = exports.VIDEO_DEFAULT_RULE = exports.VIDEO_PLATFORM_RULES = exports.VIDEO_RENDER_TIME_MULTIPLIER = exports.VIDEO_PROMPT_MAX_CHARS = exports.VIDEO_GENERATION_MAX_ATTACHMENTS = exports.VIDEO_GENERATION_ACTIVE_STATUSES = void 0;
/** Statuses where HeyGen (or our queue) still owes us a result. */
exports.VIDEO_GENERATION_ACTIVE_STATUSES = [
    "queued",
    "thinking",
    "reviewing",
    "generating",
];
/** HeyGen Video Agent accepts up to 20; Moxie keeps prompts focused (story 5.1). */
exports.VIDEO_GENERATION_MAX_ATTACHMENTS = 3;
exports.VIDEO_PROMPT_MAX_CHARS = 10000;
/** Render time is typically 5–10x the finished length; we quote the midpoint. */
exports.VIDEO_RENDER_TIME_MULTIPLIER = 7.5;
/**
 * Length and shape per network (story 5.1). Networks missing here are not
 * eligible: blogs, and Google Business posts in P0.
 */
exports.VIDEO_PLATFORM_RULES = {
    instagram: {
        targetSeconds: 40,
        minSeconds: 30,
        maxSeconds: 45,
        orientation: "portrait",
    },
    tiktok: {
        targetSeconds: 40,
        minSeconds: 30,
        maxSeconds: 45,
        orientation: "portrait",
    },
    youtube: {
        targetSeconds: 40,
        minSeconds: 30,
        maxSeconds: 45,
        orientation: "portrait",
    },
    facebook: {
        targetSeconds: 50,
        minSeconds: 45,
        maxSeconds: 60,
        orientation: "portrait",
    },
    threads: {
        targetSeconds: 50,
        minSeconds: 45,
        maxSeconds: 60,
        orientation: "portrait",
    },
    linkedin: {
        targetSeconds: 50,
        minSeconds: 45,
        maxSeconds: 60,
        orientation: "landscape",
    },
    x: {
        targetSeconds: 50,
        minSeconds: 45,
        maxSeconds: 60,
        orientation: "landscape",
    },
};
/** Standalone videos (Media Library → Create video) have no target network. */
exports.VIDEO_DEFAULT_RULE = {
    targetSeconds: 45,
    minSeconds: 30,
    maxSeconds: 60,
    orientation: "portrait",
};
const isVideoEligiblePlatform = (platform) => platform in exports.VIDEO_PLATFORM_RULES;
exports.isVideoEligiblePlatform = isVideoEligiblePlatform;
exports.VIDEO_OFFER_MAX_CHARS = 200;
/** Server returns this `code` when generate is blocked by the soft budget. */
exports.VIDEO_BUDGET_EXCEEDED_CODE = "VIDEO_BUDGET_EXCEEDED";
const estimateVideoCostCents = (seconds, pricing) => pricing ? Math.round((seconds / 60) * pricing.centsPerMinute) : null;
exports.estimateVideoCostCents = estimateVideoCostCents;
